// React
import React from 'react';
import Cleave from 'cleave.js/react';
import { Row, Col, CardBody, Label, Input } from 'reactstrap';

// Containers
import {
  InputPhone,
  InputCpfCnpj,
  ZipCodeInput,
  SelectInputCivilState,
  SelectInputWithSearchApi,
} from '../../../../containers/componentsInjection';

export const ClientDataTab = ({ validation }) => {
  return (
    <React.Fragment>
      <CardBody className="border-bottom border-bottom-dashed p-4">
        <Row>
          <Col md={12}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Dados Principais</h4>
            </Col>

            <Row>
              <Col md={8}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    Nome
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ''}
                    invalid={
                      !!(validation.touched.name && validation.errors.name)
                    }
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="cpf_client" className="form-label">
                    CPF
                  </Label>
                  <InputCpfCnpj
                    id="cpf_client"
                    name="cpf_client"
                    isCPF={true}
                    value={validation.values.cpf_client || ''}
                    onChange={(e, type) => {
                      if (type === 'CPF') {
                        validation.handleChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      validation.handleBlur(e);
                    }}
                    invalid={
                      !!(
                        validation.touched.cpf_client &&
                        validation.errors.cpf_client
                      )
                    }
                  />
                  {validation.touched.cpf_client &&
                  validation.errors.cpf_client ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cpf_client && `Digite um CPF válido`}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="rg" className="form-label">
                    RG
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="rg"
                    name="rg"
                    maxLength={11}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.rg || ''}
                  />
                </div>
              </Col>

              <Col md={2}>
                <div className="mb-3">
                  <label htmlFor="organ" className="form-label">
                    Orgão
                  </label>
                  <Cleave
                    options={{
                      delimiters: ['/'],
                      blocks: [3, 2],
                      uppercase: true,
                    }}
                    className="form-control"
                    id="organ"
                    name="organ"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.organ || ''}
                  />
                </div>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="motherName" className="form-label">
                    Nome da Mãe
                  </Label>
                  <Input
                    type="text"
                    id="motherName"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.motherName}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <label htmlFor="birth" className="form-label">
                    Data de nascimento
                  </label>
                  <Input
                    type="date"
                    className="form-control"
                    id="birth"
                    name="birth"
                    onChange={(e) => {
                      validation.handleChange(e);
                    }}
                    onBlur={validation.handleBlur}
                    value={validation.values.birth || ''}
                    invalid={
                      !!(validation.touched.birth && validation.errors.birth)
                    }
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className=" mb-3">
                  <label htmlFor="gender" className="form-label">
                    Gênero
                  </label>
                  <div className="d-flex">
                    <div
                      className="form-check"
                      style={{
                        marginRight: '10px',
                      }}
                    >
                      <Input
                        type="radio"
                        className="form-check-input"
                        name="gender"
                        id="genderMale"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        value="M"
                        checked={validation.values.gender === 'M'}
                        invalid={
                          !!(
                            validation.touched.gender &&
                            validation.errors.gender
                          )
                        }
                      />
                      <Label htmlFor="genderMale" className="form-check-label">
                        Masculino
                      </Label>
                    </div>
                    <div className="form-check">
                      <Input
                        type="radio"
                        className="form-check-input"
                        name="gender"
                        id="genderFemale"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        value="F"
                        checked={validation.values.gender === 'F'}
                        invalid={
                          !!(
                            validation.touched.gender &&
                            validation.errors.gender
                          )
                        }
                      />
                      <Label
                        htmlFor="genderFemale"
                        className="form-check-label"
                      >
                        Feminino
                      </Label>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="stateCivilInput" className="form-label">
                    Estado Civil
                  </Label>

                  <SelectInputCivilState
                    validation={validation}
                    value={validation.values.stateCivilInput}
                  />
                  {validation.touched.stateCivilInput &&
                  validation.errors.stateCivilInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.stateCivilInput}
                    </p>
                  ) : null}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>

      <CardBody className="p-4">
        <Row>
          <Col md={12}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Contatos</h4>
            </Col>

            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="email" className="form-label">
                    Email
                  </Label>
                  <Input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ''}
                    style={{
                      textTransform: 'lowercase',
                    }}
                    invalid={
                      !!(validation.touched.email && validation.errors.email)
                    }
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="phone" className="form-label">
                    Celular
                  </Label>
                  <InputPhone
                    id="phone"
                    name="phone"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone || ''}
                    invalid={
                      !!(validation.touched.phone && validation.errors.phone)
                    }
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="tel" className="form-label">
                    Telefone
                  </Label>
                  <InputPhone
                    id="tel"
                    name="tel"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.tel || ''}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>

      <CardBody className="p-4 border-top border-top-dashed">
        <Row>
          <Col md={12}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Endereço</h4>
            </Col>

            <Row>
              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="zipcode" className="form-label">
                    CEP
                  </Label>
                  <ZipCodeInput
                    className="form-control"
                    id="zipcode"
                    name="zipcode"
                    onChange={validation.handleChange}
                    changeInputs={(e) => {
                      validation.setValues({
                        ...validation.values,
                        zipcode: e.cep,
                        street: e.logradouro,
                        neighborhood: e.bairro,
                        complement: e.complemento,
                        cityInput: {
                          label: `${e.localidade} - ${e.uf} `,
                          value: e.ibge,
                        },
                      });
                    }}
                    onBlur={(e) => {
                      validation.handleBlur(e);
                    }}
                    value={validation.values.zipcode || ''}
                  />
                  {validation.touched.zipcode && validation.errors.zipcode ? (
                    <p className="labelErrorValidation">
                      {validation.errors.zipcode}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="street" className="form-label">
                    Logradouro
                  </Label>
                  <Input
                    className="form-control"
                    id="street"
                    name="street"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.street || ''}
                    invalid={
                      !!(validation.touched.street && validation.errors.street)
                    }
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="number" className="form-label">
                    Número
                  </Label>
                  <Input
                    className="form-control"
                    id="number"
                    name="number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.number || ''}
                    invalid={
                      !!(validation.touched.number && validation.errors.number)
                    }
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="complement" className="form-label">
                    Complemento
                  </Label>
                  <Input
                    className="form-control"
                    id="complement"
                    name="complement"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.complement || ''}
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="neighborhood" className="form-label">
                    Bairro
                  </Label>
                  <Input
                    className="form-control"
                    id="neighborhood"
                    name="neighborhood"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.neighborhood || ''}
                    invalid={
                      !!(
                        validation.touched.neighborhood &&
                        validation.errors.neighborhood
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="cityInput" className="form-label">
                    Cidade
                  </Label>
                  <SelectInputWithSearchApi validation={validation} />
                  {validation.touched.cityInput &&
                  validation.errors.cityInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cityInput}
                    </p>
                  ) : null}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </React.Fragment>
  );
};
